import React from 'react';

import {Sections, SectionsProps} from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNodeSection';
import {
  StandardSection,
  StandardSectionProps,
} from 'ui-library/reactflow/nodes/BenchlingNode/standard/StandardSection';

export interface StandardSectionsProps {
  /** Data about the sections to be displayed within this wrapper */
  sections: Array<StandardSectionProps>;
}

/**
 * A standard wrapper for sections within a {@link BenchlingNode}. It consumes the context provided by
 * {@link BenchlingNode}, and as such automatically handles section row counts.
 * @package
 */
export function StandardSections(props: StandardSectionsProps & SectionsProps): JSX.Element {
  const {sections, ...sectionsProps} = props;
  return (
    <Sections {...sectionsProps} pb="xs">
      {sections.map((sectionProps) => (
        <StandardSection key={sectionProps.leftHeader} {...sectionProps} />
      ))}
    </Sections>
  );
}
